import TableStatus, { TABLE_STATUS } from './TableStatus';
import KitContainer from './KitContainer';
import LabelValue from './LabelValue';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
import { ReactComponent as IconCopy } from '../../../assets/images/icon_copy.svg';
import { KindOfKit, Kit } from '../../../assets/constant/kit.type';
import iconFailTransaction from '../../../assets/images/Icon_fail_transaction.png';

const Setting = ({ kitDetail, kindOfKit, setTabIndex }: { kitDetail: Kit; kindOfKit: KindOfKit; setTabIndex: (index: number) => void }) => {
  const status =
    kitDetail?.status === 4
      ? TABLE_STATUS.DEPLOYED
      : kitDetail?.status === 3
        ? TABLE_STATUS.PROCESSING
        : kitDetail?.status === 2
          ? TABLE_STATUS.PREPARED
          : TABLE_STATUS.CREATED;
  const datas = [
    { label: 'Kit ID', value: kitDetail?.kit_id || kitDetail?.nft_kit_id },
    { label: 'Kit Name', value: kitDetail?.name },
    {
      label: 'Kit Image',
      value: <img src={kitDetail?.image} alt={''} className={'kit-info-image'} />,
    },
    { label: 'Kit Symbol', value: kitDetail?.symbol },
    { label: 'Status', value: <TableStatus status={status} /> },
    { label: 'Kit Version', value: kitDetail?.version?.version },
    {
      label: 'Kit Owner Account',
      value: (
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {kitDetail?.admin_address}
          <CopyToClipboard text={kitDetail?.admin_address} onCopy={() => toast('Owner Account Copied', { icon: '👏' })}>
            <IconCopy style={{ minWidth: 20, minHeight: 20, objectFit: 'contain', cursor: 'pointer' }} className="icon-copy" />
          </CopyToClipboard>
        </div>
      ),
    },
  ];
  return (
    <div className="tab-content-wrapper">
      {kitDetail?.status !== 4 && (
        <div style={{ padding: 20, borderRadius: 8, background: '#E4E6EB', width: '100%' }}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12, alignItems: 'center' }}>
            <img src={iconFailTransaction} alt="icon_fail_transaction" style={{ width: 24, height: 24, objectFit: 'contain' }} />
            <div style={{ fontWeight: 700, fontSize: 16, lineHeight: '21px' }}>Note : Pre-requisite for using functions</div>
          </div>
          <div
            onClick={() => setTabIndex(2)}
            style={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '20px',
              whiteSpace: 'pre-line',
              color: '#5888ff',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Deploy contract to use this kit.
          </div>
        </div>
      )}
      <KitContainer
        title={'Kit Basic Info'}
        description="The Setting tab allows users to configure kit details, manage access permissions, customize appearance, and optimize operational settings for seamless management."
      >
        {datas.map((data, index) => {
          return <LabelValue key={index} label={data.label} value={data.value} />;
        })}
      </KitContainer>
      {/*<div className="container" >*/}
      {/*  <div>*/}
      {/*    <div style={{ display: 'flex', gap: 8 }}>*/}
      {/*      <img src={iconWarning} alt="!" style={{ width: 24, height: 24, objectFit: 'contain' }} />*/}
      {/*      <div className="container-title" style={{ marginBottom: 12 }}>*/}
      {/*        Kit Deletion*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="container-description" style={{ color: '#E70707' }}>*/}
      {/*      Warning: This kit will be permanently deleted. Deleted contents cannot be recovered.*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <BasicButton style={{ alignSelf: 'flex-end' }} size={ButtonSize.ICON} theme={ButtonTheme.MINOR} onClick={() => {}}>*/}
      {/*    <img src={IconDeleteRed} style={{ width: 18, objectFit: 'contain' }} alt={'delete'} />*/}
      {/*  </BasicButton>*/}
      {/*</div>*/}
    </div>
  );
};

export default Setting;
